// extracted by mini-css-extract-plugin
module.exports = {"small":"MushroomGoldIcon_small__2XCr1","extraSmall":"MushroomGoldIcon_extraSmall__12yJn"};